import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-reset-charging-station-password-warning-dialog-content',
  templateUrl: './reset-charging-station-password-warning-dialog-content.component.html',
  styleUrls: ['./reset-charging-station-password-warning-dialog-content.component.scss']
})
export class ResetPasswordWarningDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'ResetPasswordWarningDialogContentComponent';

  public form: UntypedFormGroup;
  @Input() private entity: ChargingStation;


  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private chargingStationsService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
    });
  }

  onSubmit(formValue) {

    this.chargingStationsService.resetChargingstationPassword(this.entity.id).subscribe(result => {
      this.activeModal.close({ isSuccess: result });
    }, error => {
      this.messageService.setError(error);
    });
  }

}
